import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import StepImg01 from "../../../../../assets/image/stepimg01.svg";
import StepImg02 from "../../../../../assets/image/stepimg02.svg";
import StepImg03 from "../../../../../assets/image/stepimg03.svg";
import StepImg04 from "../../../../../assets/image/stepimg04.svg";
import { Link } from "react-router-dom";
import Image from "../../../../elements/Image";

function calculateOffset() {
  const windowWidth = window.innerWidth;
  let containerWidth = 1280;

  if (windowWidth >= 1792) {
    containerWidth = 1728; // 3xl
  } else if (windowWidth >= 1536) {
    containerWidth = 1536; // 2xl
  } else if (windowWidth >= 1280) {
    containerWidth = 1280; // xl
  } else if (windowWidth >= 1024) {
    containerWidth = 1024; // lg
  } else if (windowWidth >= 768) {
    containerWidth = 768; // md
  } else {
    containerWidth = windowWidth - 32; // sm → full width - padding
  }

  // 🟢 Small screens → safe padding
  if (windowWidth <= containerWidth) {
    return 45;
  }

  // 🟢 At exactly 1280px → no correction, align perfectly
  if (windowWidth === 1280) {
    return (windowWidth - containerWidth) / 2;
  }

  // 🟢 For >1280px (1536, 1728, 1920, etc.) → add gutter correction
  return (windowWidth - containerWidth) / 2 + 50;
}

const HomeConfidence = () => {
  const [offset, setOffset] = useState(16);

  useEffect(() => {
    const handleResize = () => setOffset(calculateOffset());
    handleResize(); // run once on mount
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const ConfidenceSlides = [
    {
      img: StepImg01,
      description: "Introducing the new Trihurst Tech checkout a faster, smarter way to buy and sell crypto.",
    },
    {
      img: StepImg02,
      description: "Trihurst Tech teams up with Quantoz to enable purchases of EURQ, USDQ, and Bitcoin.",
    },
    {
      img: StepImg03,
      description: "Introducing the new Trihurst Tech checkout — a faster, smarter way to buy and sell Ethereum.",
    },
    {
      img: StepImg04,
      description: "Say hello to smarter Litecoin trading with the new Trihurst Tech checkout solution.",
    },
    {
      img: StepImg01,
      description: "Introducing the new Trihurst Tech checkout a faster, smarter way to buy and sell crypto.",
    },
    {
      img: StepImg02,
      description: "Trihurst Tech teams up with Quantoz to enable purchases of EURQ, USDQ, and Bitcoin.",
    },
    {
      img: StepImg03,
      description: "Introducing the new Trihurst Tech checkout — a faster, smarter way to buy and sell Ethereum.",
    },
    {
      img: StepImg04,
      description: "Say hello to smarter Litecoin trading with the new Trihurst Tech checkout solution.",
    },
  ];

  return (
    <section className="relative pb-16 text-white">
      <div className="w-full max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <h2 className="text-3xl text-[40px] xl:text-[56px] font-semibold leading-[50px] xl:leading-[70px] max-w-[800px]">Step into crypto with clarity and confidence</h2>
          <div className="flex gap-3">
            <button className="swiper-prev w-10 h-10 rounded-full bg-white/10 hover:bg-white/20">
              <i class="fa-light fa-arrow-left"></i>
            </button>
            <button className="swiper-next w-10 h-10 rounded-full bg-white/10 hover:bg-white/20">
              <i class="fa-light fa-arrow-right"></i>
            </button>
          </div>
        </div>
      </div>

        <Swiper
          modules={[Navigation]}
          navigation={{ prevEl: ".swiper-prev", nextEl: ".swiper-next" }}
          slidesPerView={4}
          spaceBetween={30}
          breakpoints={{
            320: { slidesPerView: 1.2 },   
            640: { slidesPerView: 2 },     
            1024: { slidesPerView: 3 },   
            1280: { slidesPerView: 3 }, 
            1366: { slidesPerView: 4 }, 
            1440: { slidesPerView: 4 },
            1920:{ slidesPerView: 4 },
        }}
        slidesOffsetBefore={offset}
        slidesOffsetAfter={offset}
        className="!overflow-hidden confidenceslide"
        >
        {ConfidenceSlides.map((s, i) => (
          <SwiperSlide
            key={i}
            className={"w-full"}
          >
            <div className="overflow-hidden ">
              <div className="rounded-[20px] overflow-hidden aspect-[6/4]">
                <Image
                  src={s.img}
                  alt={s.title}
                  classes="object-cover"
                />
              </div>
              <div className="flex-1 flex flex-col px-5 pt-4">
                <div className="font-medium text-lg text-white leading-[30px] mb-2">
                  <p>{s.description}</p>
                </div>
                <Link
                  to={"/"}
                  className="inline-flex items-center gap-2 text-primary mt-3 text-lg"
                >
                  Read more <span><i class="fa-light fa-arrow-right"></i></span>
                </Link>
              </div>
            </div>
              
            </SwiperSlide>
          ))}
        </Swiper>
      
    </section>
  );
};

export default HomeConfidence;